import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { IconButton } from "@mui/material";
import clsx from "clsx";
import React, { useEffect, useRef } from "react";
import { currentTheme, smetaStore } from "../../../../atoms";
import { SmetaSplitterBarProps } from "./SmetaSplitterConsts";
import styles from "./splitter.module.css";

// eslint-disable-next-line @typescript-eslint/naming-convention
export default function SmetaSplitterBar(props: SmetaSplitterBarProps) {
  const theme = smetaStore.get(currentTheme);
  const separatorRef = useRef<HTMLDivElement>(null!);

  useEffect(() => {
    if (props.blockResize) {
      separatorRef.current.setAttribute("block-resize", "");
    } else separatorRef.current.removeAttribute("block-resize");
  }, [props.blockResize]);

  return (
    <div
      role="separator"
      ref={separatorRef}
      hidden={props.hideSplitter}
      className={clsx(styles["splitter-bar"], { [styles.light]: theme === "light" })}
      data-primaryelement={props.primaryIndex}
    >
      <IconButton
        color="inherit"
        size="small"
        className={styles["splitter-far-collapse-button"]}
        hidden={props.hideButtons}
      >
        <KeyboardArrowDownIcon fontSize="small" />
      </IconButton>
      <IconButton
        color="inherit"
        size="small"
        className={styles["splitter-near-collapse-button"]}
        hidden={props.hideButtons}
      >
        <KeyboardArrowDownIcon fontSize="small" />
      </IconButton>
    </div>
  );
}
